import React from "react";
import { useTranslation } from "react-i18next";

export default function ScoreChangePromptModal({
  open = false,
  previousRate,
  currentRate,
  onConfirm = () => {},
  onChangeAnswer = () => {},
}) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      className="ScreenOverlay"
      style={{ backgroundColor: "rgba(87, 122, 146, 0.45)" }}
    >
      <div
        className="ScreenContent"
        style={{
          maxWidth: "640px",
          borderRadius: "20px",
          padding: "36px 28px 28px",
          backgroundColor: "rgba(234, 245, 251, 1)",
            overflowY: "hidden",
        }}
      >
        <h2
          style={{
            margin: 0,
            marginBottom: "18px",
            textAlign: "center",
            color: "#1F1F1F",
          }}
        >
          {t("scoreChangePromptTitle")}
        </h2>

        <p
          style={{
            margin: 0,
            marginBottom: "24px",
            textAlign: "center",
            color: "#1F1F1F",
            fontSize: "18px",
            lineHeight: 1.4,
          }}
        >
          {t("scoreChangePromptDescription", {
            previousRate,
            currentRate,
          })}
        </p>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            style={{
              border: "none",
              outline: "none",
              color: "white",
              minWidth: "300px",
              padding: "10px 24px",
              borderRadius: "23px",
              boxShadow: "0px 2px 4px rgba(217, 217, 217, 1)",
              backgroundColor: "rgba(97, 132, 157, 1)",
              cursor: "pointer",
              fontSize: "16px",
            }}
            onClick={onConfirm}
          >
            {t("scoreChangePromptConfirm")}
          </button>
        </div>

        <div
          style={{
            cursor: "pointer",
            marginTop: "14px",
            textDecoration: "underline",
            textAlign: "center",
            color: "#1F1F1F",
          }}
          onClick={onChangeAnswer}
        >
          {t("scoreChangePromptChangeAnswer")}
        </div>
      </div>
    </div>
  );
}
